import React from "react"
import { useTheme } from 'react-jss'

import separatorStyles from "./separator-style"

export default function Separator({ orWording = "Or" }) {
  const theme = useTheme()
  const classes = separatorStyles(theme)

  return (
    <span className={classes.separator}>
      <span>{orWording}</span>
    </span>
  )
}
